import FlowPage from 'modules/contracts/components/FlowPage'

const RootFlowPage = () => {
  return <FlowPage />
}

export default RootFlowPage
